import Input from './src/input';

Input.install = function(Vue) {
  Vue.component(Input.name, Input);
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/input/index.js